import { graphql } from "react-relay";

export const eventSchedulerAttendeeInputFragments = {
  personsByCalendarIdsErrorable: graphql`
    fragment EventSchedulerAttendeeInput_personsByCalendarIdsErrorable on PersonListErrorable
    @argumentDefinitions(calendarIds: { type: "[String]!", defaultValue: [] }) {
      __typename
      ... on PersonList {
        list {
          id
          emails
          primaryEmail
          profile {
            givenName
            familyName
            externalImageUrl
          }
          isYou
          isOutsideOrg
        }
      }
      ... on GraphEntityError {
        message
      }
    }
  `,
};
